import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import registerPage from "@/views/activityPage/index.vue";
import startGroup from "@/views/activityPage/getSuccess.vue";
import oneImagePage from "@/views/oneImagePage/index.vue"

const routes: Array<RouteRecordRaw> = [
  {
    path: "/staticpic/:name",
    name: "staticpic",
    component: oneImagePage,
    props: true,//当 props 设置为 true 时，route.params 将被设置为组件的 props。
  },
  {
    path: "/sharepicbook/:parentId",
    name: "Home",
    component: () => import("@/views/homePage/index.vue"),
    props: true,
  },
  {
    path: "/bookgroupdisplay",
    name: "bookgroupdisplay",
    component: registerPage,
    props: true,//当 props 设置为 true 时，route.params 将被设置为组件的 props。
  },
  {
    path: '/mathanswer1',
    name: 'mathanswer1',
    component: () => import('@/views/mathanswerPage/mathanswer1.vue'),
    props: true
  },
  {
    path: '/mathanswer2',
    name: 'mathanswer2',
    component: () => import('@/views/mathanswerPage/mathanswer2.vue'),
    props: true
  },
  {
    path: '/mathanswer3',
    name: 'mathanswer3',
    component: () => import('@/views/mathanswerPage/mathanswer3.vue'),
    props: true
  },
  {
    path: "/startGroup/:pid",
    name: "startGroup",
    component: startGroup,
    props: true,
  },
  {
    path: "/captcha",
    name: "captcha",
    component: () => import("@/views/captcha.vue"),
    props: true,
  },
  {
    path: "/publicvideoclass1",
    name: "publicvideoclass1",
    component: () => import("@/views/publicvideoclass1.vue"),
    props: true,
  },
  {
    path: "/success/:parentId",
    name: "success",
    component: () => import("@/views/homePage/success.vue"),
    props: true,
  },
  {
    path: "/submitSuccess",
    name: "submitSuccess",
    component: () => import("@/views/tutor/submitSuccess.vue"),
    props: true,
  },
  {
    path: "/tutorSubmit",
    name: "tutorSubmit",
    component: () => import("@/views/tutor/tutorSubmit.vue"),
    props: true,
  },
  {
    path: "/tutorSubmit",
    name: "tutorSubmit",
    component: () => import("@/views/tutor/tutorSubmit.vue"),
    props: true,
  },
  {
    path: "/tutorSubmitMath",
    name: "tutorSubmitMath",
    component: () => import("@/views/tutorMath/tutorSubmit.vue"),
    props: true,
  },
  {
    path: "/submitSuccessMath",
    name: "submitSuccessMath",
    component: () => import("@/views/tutorMath/submitSuccess.vue"),
    props: true,
  },
  {
    path: "/submitErrorMath",
    name: "submitErrorMath",
    component: () => import("@/views/tutorMath/submitError.vue"),
    props: true,
  },
  {
    path: "/chinesePublic",
    name: "chinesePublic",
    component: () => import("@/views/publicPage/chinesePublic.vue"),
    props: true,
  },
  {
    path: "/mathPublic",
    name: "mathPublic",
    component: () => import("@/views/publicPage/mathPublic.vue"),
    props: true,
  },
  {
    path: "/englishPublic",
    name: "englishPublic",
    component: () => import("@/views/publicPage/englishPublic.vue"),
    props: true,
  },
  {
    path: "/:catchAll(.*)",
    name: "404",
    component: () => import("@/views/404.vue"),
  },
  {
    path: "/groupBuying",
    name: "groupBuying",
    component: () => import("@/views/groupBuying/GroupBuyingPage.vue"),
    props: true
  },
  {
    path: "/groupBuying/notStart",
    name: "notStart",
    component: () => import("@/views/groupBuying/notStart.vue")
  },
  {
    path: "/groupBuying/notStart/claimedSuccessfully",
    name: "claimedSuccessfully",
    component: () => import("@/views/groupBuying/ClaimedSuccessfully.vue"),
    props: true
  },
  {
    path: "/groupBuying/start",
    name: "startGroupBuying",
    component: () => import("@/views/groupBuying/StartGroupBuying.vue")
  },
  {
    path: "/groupBuying/success",
    name: "groupBuyingSuccess",
    component: () => import("@/views/groupBuying/GroupBuyingSuccess.vue")
  },
  {
    path: "/joinGroup",
    name: "joinGroup",
    component: () => import("@/views/groupBuying/JoinGroupIndexPage.vue")
  },
  {
    path: "/joinGroup/login",
    name: "joinGroupLogin",
    component: () => import("@/views/groupBuying/JoinGroupLogin.vue")
  },
  {
    path: "/joinGroup/join",
    name: "joiningGroup",
    component: () => import("@/views/groupBuying/JoinGroup.vue")
  },
  {
    path: "/joinGroup/failed",
    name: "joinGroupFailed",
    component: () => import("@/views/groupBuying/JoinGroupFailed.vue")
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
